import React from 'react';

type SelectOptionProps = {
  disabled?: boolean;
  children: string;
  value: string;
};

export const SelectOption: React.FC<SelectOptionProps> = ({
  children,
  disabled = false,
  value,
}: SelectOptionProps): JSX.Element => {
  return (
    <option value={value} disabled={disabled} className="select__option">
      {children}
    </option>
  );
};
